import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { AgGridActionbutton } from "src/app/shared/common/AgGridActionbutton";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";


interface ValidationError {
  component: string;
  field?: string;
  message: string;
}

interface ValidationResult {
  valid: boolean;
  errors: ValidationError[];
}

@Component({
    selector: "app-signal-attachment",
    templateUrl: "./signal-attachment.component.html",
    styleUrls: ["./signal-attachment.component.scss"],
    standalone: false
})
export class SignalAttachmentComponent implements OnInit {
  @Input() signalId!: any;
  @Input() stepId!: number;
  @Input() selectedSignal!: any;

  attachments: any[] = [];
  attachmentColumns = ["name", "size", "uploaded", "actions"];
  newLink: any;
  links: any[] = [];
  defaultColDef = {
  sortable: true,
  filter: true,
  resizable: true
};
columnDefs: any[] = [];
linkColumnDefs: any[] = [];
components: any;


  constructor(
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private jsignalsService: JsignalService,
  ) { 
    this.components = {
          jsignalButton: JSIGNALBUTTON,
          buttonRenderer: AgGridActionbutton,
        };
      }

  ngOnInit(): void {
    this.initializeGrid();
    
    console.log("Signal ID:", this.signalId);
    console.log("Step ID:", this.stepId);
    console.log("Selected Signal:", this.selectedSignal);
    console.log("Product Id:", this.selectedSignal?.productId);

    this.loadAttachmentDataBasedOnSignalId();
    this.getLinksBasedOnSignalId();
  }



  onFileSelected(event: any): void {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    const allowedTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/plain',
    'image/jpeg',
    'image/jpg',
    'image/png'
  ];

  const validFiles: File[] = [];

  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    if (!allowedTypes.includes(file.type)) {
      console.warn(`Invalid file type: ${file.name}`);
      continue;
    }

    validFiles.push(file);
  }

  if (validFiles.length > 0) {
    this.uploadAttachments(validFiles);
  }

    // const newFiles = Array.from(files).map((file) => ({
    //   name: file.name,
    //   size: file.size,
    //   uploaded: new Date(),
    //   file,
    // }));

    // this.attachments = [...this.attachments, ...newFiles];
    event.target.value = "";
  }

addLink(linkCtrl: any): void {
  linkCtrl.control.markAsTouched();

  if (!this.newLink?.trim()) {
    this.snackBar.open("Link cannot be empty", "Ok", { duration: 3000 });
    return;
  }

  let url = this.newLink.trim();

  // Auto handle www
  if (url.startsWith('www.')) {
    url = 'https://' + url;
  }

  if (!this.isValidUrl(url)) {
    this.snackBar.open("Enter valid URL", "Ok", { duration: 3000 });
    return;
  }

  this.uploadLinks([url]);
  this.newLink = '';
}

    removeLink(data: any): void {
      console.log("Link to delete:", data);
      console.log("Link id to delete:", data.rowData.id);
    // if (this.isViewOnly) return;
    // this.links = this.links.filter(l => l !== data);
    this.deleteLink(data.rowData.id);
  }

  removeAttachment(file: any): void {
    this.attachments = this.attachments.filter((f) => f !== file);
  }

  validateStep(): ValidationResult {

  const errors: ValidationError[] = [];

  if (this.stepId === 3 && this.attachments.length === 0) {
    errors.push({
      component: 'Attachment',
      message: 'Attachment required for Assessment'
    });
  }

  return {
    valid: errors.length === 0,
    errors
  };
}

uploadAttachments(files: File[]): void {
  this.spinner.start();
  this.jsignalsService
    .uploadSignalAttachments(this.signalId, this.selectedSignal.productId, files)
    .subscribe({
      next: (res: any) => {
        console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.loadAttachmentDataBasedOnSignalId();
            this.spinner.stop();
            
           
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.loadAttachmentDataBasedOnSignalId();
          this.spinner.stop();
         

        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
         this.loadAttachmentDataBasedOnSignalId();
          this.spinner.stop();
         
        },
      });  
}

initializeGrid(){
  this.columnDefs = [
  {
    headerName: 'File Name',
    field: 'fileName',
    flex: 2
  },
  {
    headerName: 'File Path',
    field: 'filePath',
    flex: 1
  },
  //   {
  //   headerName: 'Uploaded By',
  //   field: 'uploadedBy',
  //   flex: 1
  // },
  {
    headerName: 'Uploaded Date',
    field: 'uploadedAt',
    flex: 1
  },
 {
        headerName: "Action",
        sortable: false,
        filter: false,
        resizable: true,
        width: 200,
        cellRenderer: 'jsignalButton',
        pinned: "right",
        lockPinned: true,
      cellRendererParams: () => ({
        download: (data: any) => this.download(data),
        PopUpDelete: (data: any) => this.DeleteIcon(data),
      }),
      },];

       // -------- LINKS GRID --------
  this.linkColumnDefs = [
    {
      headerName: 'Link',
      field: 'fileName',
      flex: 2,
      cellRenderer: (params: any) => {
        return `<a href="${params.value}" target="_blank">${params.value}</a>`;
      }
    },
    {
      headerName: 'Added Date',
      field: 'uploadedAt',
      flex: 1,
      valueFormatter: (params: any) => {
        return params.value ? new Date(params.value).toLocaleString() : '';
      }
    },
    {
      headerName: "Action",
      sortable: false,
      filter: false,
      resizable: true,
      width: 150,
      cellRenderer: 'jsignalButton',
      pinned: "right",
      lockPinned: true,
      cellRendererParams: (params: any) => ({
        //no download for links
        PopUpDelete: (data: any) => this.removeLink(data),
        // OPTIONAL add popupedit 
        // edit: (data: any) => this.editLink(data)
      }),
    }
  ];

}

loadAttachmentDataBasedOnSignalId() {
   this.spinner.start();
   this.jsignalsService
    .loadAttachmentData(this.signalId)
    .subscribe({
      next: (res: any) => {
        console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.attachments = [];
            this.spinner.stop();
           
            return;
          }
          // this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.attachments = res || [];
          this.spinner.stop();
         

        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
         this.attachments = [];
          this.spinner.stop();
         
        },
      });  

}

download(params: any) {
  debugger;
  this.snackBar.open("Downloading attachment... please wait until the download starts. do not click download again.", "Ok", { duration: 5000 }); 
 this.spinner.start();

this.jsignalsService.downloadAttachment(params.rowData.id).subscribe({
  next: (res) => {
    console.log(res.headers.keys());
    console.log(res.headers.get('content-type'));
    console.log(res.headers.get('Content-Disposition'));
    const blob = res.body as Blob;

    const contentDisposition = res.headers.get('Content-Disposition');
    let fileName = params.rowData.fileName; // Default to the name from rowData if header is missing

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+)"/);
      if (match && match[1]) {
        fileName = match[1];
      }
    }

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.href = url;
    a.download = fileName;
    a.click();

    window.URL.revokeObjectURL(url);
  },
  error: () => {
    this.snackBar.open("Download failed", "Ok", { duration: 3000 });
  },
  complete: () => {
    this.spinner.stop();
  }
});

}

DeleteIcon(params: any) {
  console.log("Attachment to delete:", params.rowData.id);
  this.spinner.start();
this.jsignalsService
    .deleteAttachment(params.rowData.id)
    .subscribe({
      next: (res: any) => {
        console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            // this.attachments = [];
            this.loadAttachmentDataBasedOnSignalId();
            this.spinner.stop();
           
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          // this.attachments = res || [];
          this.loadAttachmentDataBasedOnSignalId();
          this.spinner.stop();
         

        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
        //  this.attachments = [];
         this.loadAttachmentDataBasedOnSignalId();
          this.spinner.stop();
         
        },
      });  
}

getLinksBasedOnSignalId() {
  this.spinner.start();
console.log("Signal Id :", this.signalId);
this.jsignalsService
    .getSignalLinksBasedOnSignalId(this.signalId)
    .subscribe({
      next: (res: any) => {
        console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
          // this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.links = res;
          this.spinner.stop();
         

        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.links = [];
        //  this.loadAttachmentDataBasedOnSignalId();
          this.spinner.stop();
         
        },
      });  
}

onAttachmentRefresh(){
this.loadAttachmentDataBasedOnSignalId();
}

onLinksRefresh(){
this.getLinksBasedOnSignalId();
}

uploadLinks(links: any[]): void {
  this.spinner.start();
  this.jsignalsService
    .uploadSignalAttachments(this.signalId, this.selectedSignal.productId, [], links)
    .subscribe({
      next: (res: any) => {
        console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.getLinksBasedOnSignalId();
            this.spinner.stop();
            
           
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.getLinksBasedOnSignalId();
          this.spinner.stop();
         

        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
         this.getLinksBasedOnSignalId();
          this.spinner.stop();
         
        },
      });  
}

isValidUrl(url: string): boolean {
  try {
    // Handle "www." case
    if (url.startsWith('www.')) {
      url = 'https://' + url;
    }

    const parsed = new URL(url);

    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch (err) {
    console.error(`Invalid URL: ${url}`, err);
    return false;
  }
}

deleteLink(id:number): void {
  this.spinner.start();
  this.jsignalsService
    .deleteAttachment(id)
    .subscribe({
      next: (res: any) => {
        console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.links = [];
            this.getLinksBasedOnSignalId();
            this.spinner.stop();
           
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.getLinksBasedOnSignalId();
          this.spinner.stop();
         

        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.links = [];
          this.getLinksBasedOnSignalId();
          this.spinner.stop();
         
        },
      });  
    }

}
